import { View } from 'react-native'
import { useIsBenefitScreenPresentedAsModal } from '@/src/experiences/card-benefits/components/BenefitModal'
import { DesignSystem } from '@/src/design-system'

export function CardBenefitsComponentsTerms({ terms }: { terms: readonly string[] }) {
  const isBenefitScreenPresentedAsModal = useIsBenefitScreenPresentedAsModal()

  return (
    <View
      style={[{ marginVertical: 32 }, isBenefitScreenPresentedAsModal && { marginHorizontal: 24 }]}
    >
      <DesignSystem.Markdown children={terms.join('')} />
    </View>
  )
}
